// extracted by mini-css-extract-plugin
export default {"repeatSendCode":"n3tmC","resendText":"bjErs","repeatCode":"Y4Swh","changeDataButton":"ff6Yq","error":"fKNwG"};